"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _useAddressSearch2 = require("../../hooks/questionnaire/useAddressSearch");
var _services = require("../../services");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var QuestionWithAddressSearch = function QuestionWithAddressSearch(_ref) {
  var question = _ref.question,
    selections = _ref.selections;
  var _useAddressSearch = (0, _useAddressSearch2.useAddressSearch)(question, selections),
    addressSuggestions = _useAddressSearch.addressSuggestions,
    address = _useAddressSearch.address,
    streetNumber = _useAddressSearch.streetNumber,
    onStreetNumberChange = _useAddressSearch.onStreetNumberChange,
    minCharacters = _useAddressSearch.minCharacters,
    onChange = _useAddressSearch.onChange,
    onSelect = _useAddressSearch.onSelect,
    onFilter = _useAddressSearch.onFilter;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SearchSuggestionWithLabel, {
    fieldWrapper: {
      label: '',
      width: 'full'
    },
    searchSuggestion: {
      suggestions: addressSuggestions,
      value: address,
      type: 'text',
      id: 'address-search',
      placeholder: _services.locale.localeString('Questionnaire.AddressSelectorPlaceholder'),
      minCharacters: minCharacters,
      onChange: onChange,
      onSelect: onSelect,
      handleFiltering: function handleFiltering(value) {
        return onFilter(value);
      }
    }
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.TextInputWithLabel, {
    fieldWrapper: {
      label: '',
      width: 'full'
    },
    textInput: {
      type: 'text',
      id: 'address-street-number',
      placeholder: _services.locale.localeString('Questionnaire.streetNumberPlaceholder'),
      value: streetNumber,
      onChange: function onChange(e) {
        return onStreetNumberChange(e.target.value);
      }
    }
  }));
};
var _default = QuestionWithAddressSearch;
exports.default = _default;